import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchPartsSalesList = (parameters = {}) => {
  const allFilters = getUrlParameters(parameters);

  return apiActionCreator({
    'endpoint': `/parts/sales${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_PARTS_SALES_LIST,
      ActionTypes.FETCHED_PARTS_SALES_LIST,
      [
        ActionTypes.FETCHED_PARTS_SALES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadPartsSalesList = (parameters = {}) => {
  const allFilters = getUrlParameters(parameters);

  return apiActionCreator({
    'endpoint': `/parts/sales/excel${allFilters}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOADING_PARTS_SALES_LIST,
      ActionTypes.DOWNLOADED_PARTS_SALES_LIST,
      [
        ActionTypes.DOWNLOADED_PARTS_SALES_LIST_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};
